module.exports = __webpack_public_path__ + "img/ic_collapse.78b685b2.svg";